// Compiled at 2026-10-07T06:21:14.844Z
// Auto-generated by Lowgile
import * as LowgileDataUtil from "@lg/shared";
import * as Ramda from "ramda";
import * as $Modules from "../../Module/$modules.js";
import { System, System as This } from "../../Module/$modules.js";
import type { HasId, IdType, Class, DeepReadonly, NominalType } from "@lg/shared";
import { Sys, ExecutionService } from "@lg/ng-shared";
// Auto-generated by Lowgile
import { addQueryParametersToUrl } from "@lg/shared";
import { ScreenDefinition } from "@lg/shared";
import { FrontendScreenBridge } from "@lg/ng-shared";

export const $Screens = {
};
